$(function(){
    var mql = window.matchMedia("(max-width: 1023px)")
  
    mediaqueryresponse(mql)
  
    mql.addListener(mediaqueryresponse)
  
    function mediaqueryresponse(mql) {
      if (mql.matches) {   
        $('.promo-full-width').each(function(){
            var $playbtn = $(this).find('.video_modal');
            if($playbtn.length > 0){
                var $headline = $(this).find('.promo-full__headline');
                var $description = $(this).find('.promo-full__description');
                if($description.length > 0){
                    $description.css('margin-bottom', '170px');
                    $playbtn.css('top', '75%')
                }else if($description.length == 0){
                    $headline.css('margin-bottom', '270px');
                }
            }
        })
      }
    } 
})